// 店铺装修状态

// 店铺审核状态
export enum ShopInfoAuditEnum {
  AUDIT, // 待审核
  REJECTED, // 拒绝
  SUCCESS // 通过
}

// 审核状态可选的字符串
export enum AuditIconStatusEnum {
  REJECTED = 'rejected',
  VERIFYING = 'verifying',
  SUCCESS = '',
}

// 服务说明状态
export enum ServiceConfigAuditEnum {
  AUDIT, // 待审核
  SUCCESS, // 通过
  REJECTED // 拒绝
}
